/* Contact + newsletter forms: Shopify redirects with ?contact_posted=true / ?customer_posted=true (or renders form.errors in Liquid).
   This only toggles the static success/error blocks for the HTML export; in Liquid use {% form %} + form.posted_successfully?. */
document.addEventListener('DOMContentLoaded', () => {
  const q = location.search;
  document.querySelectorAll('[data-soh-form]').forEach(f => {
    const type = f.dataset.sohForm; const ok = q.includes(type + '_posted=true');
    f.querySelector('[data-form-success]') && (f.querySelector('[data-form-success]').hidden = !ok);
    if (ok) f.querySelector('form') && (f.querySelector('form').hidden = true);
    f.querySelector('form')?.addEventListener('submit', (e) => {
      const bad = [...e.target.querySelectorAll('[required]')].filter(i => !i.value.trim() || (i.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(i.value)));
      const err = f.querySelector('[data-form-error]');
      if (bad.length) { e.preventDefault(); bad.forEach(i => i.setAttribute('aria-invalid', 'true')); if (err) { err.hidden = false; err.textContent = 'Please fill in ' + bad.map(i => (i.labels[0] || {}).textContent || i.name).join(', ').toLowerCase() + '.'; } bad[0].focus(); }
    });
  });
});
